<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="type == 3 ? '70%' : '60%'"
    class="bindElevatorDialog"
  >
    <el-form class="toolbar-form" :inline="true" v-model="form" label-width>
      <el-form-item :label="$l('城市')">
        <el-input v-model="form.city" :placeholder="$l('城市')"></el-input>
      </el-form-item>
      <el-form-item :label="$l('地盘名称')">
        <el-input
          v-model="form.domainName"
          :placeholder="$l('地盘名称')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$l('工号')">
        <el-input v-model="form.jobNum" :placeholder="$l('工号')"></el-input>
      </el-form-item>
      <template v-if="type == 3">
        <el-form-item :label="$l('电梯类型')">
          <el-select
            v-model="form.elevatorType"
            :popper-append-to-body="false"
            :placeholder="$l('电梯类型')"
          >
            <el-option :label="$l('全部')" value></el-option>
            <el-option :label="$l('直梯')" value="直梯"></el-option>
            <el-option :label="$l('扶梯')" value="扶梯"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$l('监控状态')">
          <el-select
            v-model="form.monitorStatus"
            :popper-append-to-body="false"
            :placeholder="$l('监控状态')"
          >
            <el-option :label="$l('全部')" value=""></el-option>
            <el-option :label="$l('正常监视')" value="1"></el-option>
            <el-option :label="$l('异常')" value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button
          icon="el-icon-search"
          type="primary"
          circle
          @click="searchElevator"
        ></el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="elevatorTable"
      highlight-current-row
      v-loading.lock="loading"
      :data="tableData"
      max-height="300px"
      style="width: 100%; z-index: 1000"
      @select="selectElevator"
      @select-all="selectAllElevator"
      stripe=""
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :label="$l('序号')"
        min-width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        property="city"
        :label="$l('城市')"
        min-width="150"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="domainName"
        :label="$l('地盘')"
        min-width="150"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="buildingName"
        :label="$l('大楼名称')"
        min-width="150"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="elevatorNum"
        :label="$l('梯号')"
        min-width="150"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="jobNum"
        :label="$l('工号')"
        min-width="150"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <template v-if="type == 3">
        <el-table-column
          :label="$l('电梯类型')"
          prop="elevatorType"
          align="center"
          min-width="120"
          :formatter="elevatorTypeFormatter"
        ></el-table-column>
        <el-table-column
          :label="$l('监控状态')"
          prop="isactive"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <div
              style="width: 74px; height: 20px; margin: 0 auto"
              v-if="scope.row.isactive == 1"
            >
              <span style="color: #8ae4ef">{{ $l("正常监视") }}</span>
            </div>
            <div style="width: 74px; height: 20px; margin: 0 auto" v-else>
              <span style="color: #fb5c5d">{{ $l("异常") }}</span>
            </div>
          </template>
        </el-table-column></template
      >
    </el-table>
    <el-pagination
      :current-page="pageConfig.currentPage"
      :page-sizes="pageConfig.pageSizes"
      :page-size="pageConfig.pageSize"
      :total="pageConfig.total"
      @size-change="handlePageSizeChange"
      @current-change="handleCurrentPageChange"
      :popper-class="pageClass"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <el-tabs>
      <el-tab-pane :label="$l('已选')">
        <div class="selectedElevator">
          <span v-for="(v, i) in jobNumList" :key="i">
            <el-tag closable @close="closeTag(v)">{{ v }}</el-tag>
          </span>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clearSelectedElevator">{{ $l("清 空") }}</el-button>
      <el-button @click="cancelBindElevator">{{ $l("取 消") }}</el-button>
      <el-button type="primary" @click="bindElevator">{{
        $l("确 定")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "bindElevator",
  mixins: [global],
  props: { pageClass: String },
  data() {
    return {
      screen: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        pageName: "",
        city: "",
        domainName: "",
        jobNum: "",
        userId: null,
        monitorStatus: null,
        elevatorType: null,
      },
      tableData: [],
      loading: false,
      visible: false,
      jobNumList: [],
      liftInfoList: [],
      title: "",
      type: 1,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    show(userId, type) {
      this.type = type;
      this.title =
        type == 1
          ? this.$l("单梯设置")
          : type == 2
          ? this.$l("多梯设置")
          : this.$l("选择电梯");
      this.visible = true;
      this.form.userId = userId;
      if (this.type == 3) {
        this.tableData.length == 0 && this.initData();
        return;
      }
      this.jobNumList = [];
      this.liftInfoList = [];
      this.$http
        .get(this.$apiConfig.get_bind_monitor_elevator_url, {
          params: {
            userId: this.form.userId,
            type: type,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.jobNumList = result.data;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
      this.initData();
    },
    initData() {
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.form.pageName = this.type == 3 ? "bigscreen" : "lift";
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.$nextTick(() => {
              this.tableData.forEach((row, i) => {
                if (
                  this.jobNumList.filter((v) => v == row.jobNum).length == 1
                ) {
                  this.$refs.elevatorTable.toggleRowSelection(row, true);
                }
              });
            });
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    searchElevator() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    selectElevator(selection, row) {
      let flag = false;
      selection.forEach((item, i) => {
        if (this.jobNumList.filter((v) => v == item.jobNum).length == 0) {
          this.jobNumList.push(item.jobNum);
          if (this.type == 3) this.liftInfoList.push(item);
        }
        if (!flag && item.jobNum == row.jobNum) {
          flag = true;
        }
      });
      if (!flag) {
        flag = false;
        let index = -1;
        this.jobNumList.forEach((v, i) => {
          if (v == row.jobNum) {
            flag = true;
            index = i;
          }
        });
        if (flag) {
          this.jobNumList.splice(index, 1);
          if (this.type == 3) this.liftInfoList.splice(index, 1);
        }
      }
    },
    selectAllElevator(selection) {
      if (selection.length > 0) {
        selection.forEach((item, i) => {
          if (this.jobNumList.filter((v) => v == item.jobNum).length == 0) {
            this.jobNumList.push(item.jobNum);
            if (this.type == 3) this.liftInfoList.push(item);
          }
        });
      } else {
        let indexs = [];
        this.jobNumList.forEach((v, i) => {
          if (this.tableData.filter((t) => t.jobNum == v).length == 1) {
            indexs.push(i);
          }
        });
        if (indexs.length > 0) {
          let temp = 0;
          for (let i = 0; i < indexs.length; i++) {
            this.jobNumList.splice(indexs[i] - temp, 1);
            if (this.type == 3) this.liftInfoList.splice(indexs[i] - temp, 1);
            temp++;
          }
        }
      }
    },
    clearSelectedElevator() {
      this.jobNumList = [];
      this.liftInfoList = [];
      this.tableData.forEach((row, i) => {
        this.$refs.elevatorTable.toggleRowSelection(row, false);
      });
    },
    cancelBindElevator() {
      this.visible = false;
    },
    closeTag(val) {
      let index = -1;
      this.jobNumList.forEach((v, i) => {
        if (v == val) {
          this.tableData.forEach((row, ii) => {
            if (v == row.jobNum) {
              this.$refs.elevatorTable.toggleRowSelection(row, false);
            }
          });
          index = i;
        }
      });
      if (index >= 0) {
        this.jobNumList.splice(index, 1);
        if (this.type == 3) this.liftInfoList.splice(index, 1);
      }
    },
    bindElevator() {
      if (this.type == 3) {
        if (this.liftInfoList.length == 0) {
          return this.message(1, this.$l("请选择电梯"));
        }
        if (this.liftInfoList.length > 6) {
          return this.message(1, this.$l("选择的数据不能超过6条"));
        }
        this.$emit("selected", this.liftInfoList);
        this.visible = false;
        return;
      }
      if (this.jobNumList.length > 20) {
        this.message(1, this.$l("选择的数据不能超过20条"));
        return;
      }
      this.$http
        .post(this.$apiConfig.set_bind_monitor_elevator_url, {
          userId: this.form.userId,
          type: this.type,
          jobNumList: this.jobNumList,
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.visible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    elevatorTypeFormatter(row) {
      return this.$l(row.elevatorType);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.bindElevatorDialog {
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px 20px;
  }
  .selectedElevator {
    max-height: 100px;
    overflow: auto;
    span {
      display: inline-block;
      margin-bottom: 4px;
      margin-right: 4px;
    }
  }
}
</style>
